var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 95,
    viewBox: "0 0 109 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_78_968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2558 29.4749C18.2131 25.1801 12.1952 18.5373 5.23725 15.9417C4.20938 15.052 2.52261 15.2861 1.45959 16.0822C1.44202 16.0956 1.42445 16.1023 1.40688 16.1156C1.38052 16.1357 1.35416 16.1558 1.32781 16.1759C0.256006 16.9519 -0.10419 18.2162 1.01154 19.0257C4.18302 24.4978 12.0458 29.5151 16.9568 34.1109C24.2661 40.9477 31.3559 47.925 38.5422 54.8355C52.7128 68.4422 66.822 82.6177 84.1026 94.0436C87.4674 96.2713 94.2057 94.4115 92.5189 90.5048C90.8409 86.6248 57.3163 60.7224 45.5353 49.6777C38.2435 42.8476 30.9517 36.0375 23.2471 29.4682L23.2558 29.4749Z",
    fill: "#D85836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9897 0.649136C24.2224 -1.29087 20.4623 1.53217 22.8255 3.71969C48.7245 27.7691 76.1258 51.8117 99.0114 77.5402C101.735 81.641 110.986 78.7376 108.043 73.8274C100.101 60.602 85.157 49.6577 72.7346 38.8605C57.7118 25.8224 43.7784 12.4497 26.9897 0.649136Z",
    fill: "#D85836"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108.261,
    height: 95,
    fill: "white",
    transform: "translate(0.335449)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.653ed8037a4f40295d272da3ff6c3701.svg";
export { ForwardRef as ReactComponent };